













































































































































































































































































































































import { Component, Prop, Vue, Ref, Watch } from "vue-property-decorator";
import { TreatmentDatabasesApi } from "../../../apis";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import { subtract } from "lodash";
import { AxiosResponse } from "axios";
import VueI18n from "vue-i18n";
import ConfirmDialog from "../../components/user-management/ConfirmDialog.vue";
import { required } from "vee-validate/dist/rules";
import {
  RPA_TEMPLATE,
  IRule,
  RPA_RULE_SINCE,
  RPA_RULE_COMPARISION_TYPE,
  RPA_RULE_COMPARISION_OPERATOR,
  RPA_RULE_EXECUTION_TIME,
  TIME_FORMAT,
  RPA_RULE_ACTION,
  PHASE,
} from "./index";

@Component({
  components: { ValidationProvider, ValidationObserver, ConfirmDialog },
})
export default class RuleTemplate extends Vue {
  showPanels = [0];
  @Prop({ default: [] }) variableOptions;
  @Prop({ default: [] }) packageOptions;
  @Prop({ default: {} }) ruleTemplate: IRule;
  @Prop({ default: false }) isViewMode: boolean;


  get variableOptionsByTemplate() {
    if (this.isTemplate1 || this.isTemplate2) {
      return this.variableOptions.filter(variable => ["BYTE", "UBYTE", "WORD" , "FLOATING"].includes(variable.type));
    }
    if (this.isTemplate3) {
      return this.variableOptions.filter(variable => variable.type === "BOOL");
    }
    return [];
  }

  calculationSignOptions = [
    { value: "+", text: "+" },
    { value: "-", text: "-" },
  ];
  selectedSince = "";
  sinceOptions = [
    {
      value: RPA_RULE_SINCE.RPA_RULE_SINCE_BEGINNING,
      text: this.$t("text.beginThePhase"),
    },
    { value: RPA_RULE_SINCE.RPA_RULE_SINCE_RANGE, text: this.$t("text.range") },
  ];

  conditionTypeOptions = [
    {
      value: RPA_RULE_COMPARISION_TYPE.COMPARISION_TYPE_UP,
      text: this.$t("text.Up"),
    },
    {
      value: RPA_RULE_COMPARISION_TYPE.COMPARISION_TYPE_DOWN,
      text: this.$t("text.Down"),
    },
  ];

  comparisonOptions = [
    {
      value: RPA_RULE_COMPARISION_OPERATOR.OPERATOR_GT,
      text: RPA_RULE_COMPARISION_OPERATOR.OPERATOR_GT,
    },
    {
      value: RPA_RULE_COMPARISION_OPERATOR.OPERATOR_GTE,
      text: RPA_RULE_COMPARISION_OPERATOR.OPERATOR_GTE,
    },
    {
      value: RPA_RULE_COMPARISION_OPERATOR.OPERATOR_LT,
      text: RPA_RULE_COMPARISION_OPERATOR.OPERATOR_LT,
    },
    {
      value: RPA_RULE_COMPARISION_OPERATOR.OPERATOR_LTE,
      text: RPA_RULE_COMPARISION_OPERATOR.OPERATOR_LTE,
    },
    {
      value: RPA_RULE_COMPARISION_OPERATOR.OPERATOR_EQUAL,
      text: RPA_RULE_COMPARISION_OPERATOR.OPERATOR_EQUAL,
    },
  ];

  afterOptions = [
    {
      value: RPA_RULE_EXECUTION_TIME.EXECUTION_AFTER_TIME,
      text: this.$t("text.after"),
    },
    {
      value: RPA_RULE_EXECUTION_TIME.EXECUTION_INTERVAL,
      text: this.$t("text.afterEveryInterval"),
    },
    {
      value: RPA_RULE_EXECUTION_TIME.EXECUTION_INTERVAL_END_PHASE,
      text: this.$t("text.afterEveryIntervalEndPhase"),
    },
  ];

  valueBooleanOptions = [
    {
      value: "1",
      text: this.$t("text.True")
    },
    {
      value: "0",
      text: this.$t("text.False")
    }
  ];

  readonly TECHNICAL_CHECKING = {
    value: RPA_RULE_ACTION.ACTION_TECHNICAL_CHECKING,
    text: this.$t("text.technicalChecking"),
  };
  readonly WAITING_TECHNICAL_CHECKING = {
    value: RPA_RULE_ACTION.ACTION_WAITING_TECHNICAL_CHECKING,
    text: this.$t("text.waitingTechnicalChecking"),
  };
  readonly REACHING_SETPOINT = {
    value: RPA_RULE_ACTION.ACTION_REACHING_SETPOINT,
    text: this.$t("text.reachingSetpointExpectedEndTime"),
  };
  readonly RECOUNT_TREATMENT = {
    value: RPA_RULE_ACTION.ACTION_RECOUNT_TREATMENT,
    text: this.$t("text.recountTreatmentTime"),
  };
  get actionOptions() {
    if (this.ruleTemplate.phase === PHASE.PHASE_1) {
      return [this.TECHNICAL_CHECKING, this.WAITING_TECHNICAL_CHECKING];
    }
    if (this.ruleTemplate.phase === PHASE.PHASE_2) {
      return [this.TECHNICAL_CHECKING, this.REACHING_SETPOINT];
    }
    if (this.ruleTemplate.phase === PHASE.PHASE_3) {
      return [this.TECHNICAL_CHECKING, this.RECOUNT_TREATMENT];
    }
    return [this.TECHNICAL_CHECKING];
  }

  get afterIsInterVal() {
    return (
      this.ruleTemplate.dataTemplate.execAfter ===
      RPA_RULE_EXECUTION_TIME.EXECUTION_INTERVAL
    );
  }

  timeOptions = [
    { value: TIME_FORMAT.MINUTES, text: this.$t("text.MINUTES") },
    { value: TIME_FORMAT.HOURS, text: this.$t("text.HOURS") },
  ];

  get isTemplate1() {
    return this.ruleTemplate.rpaTemplate === RPA_TEMPLATE.TEMPLATE_1;
  }

  get isTemplate2() {
    return this.ruleTemplate.rpaTemplate === RPA_TEMPLATE.TEMPLATE_2;
  }

  get isTemplate3() {
    return this.ruleTemplate.rpaTemplate === RPA_TEMPLATE.TEMPLATE_3;
  }

  get isDisableSince() {
    return this.isTemplate2 || this.isTemplate3;
  }

  get isTreatmentRPA() {
    return this.ruleTemplate.phase !== PHASE.PHASE_OTHER;
  }

  get isOtherRPA() {
    return this.ruleTemplate.phase === PHASE.PHASE_OTHER;
  }

  get sinceRangeSelected() {
    return (
      this.ruleTemplate.dataTemplate.since ===
      RPA_RULE_SINCE.RPA_RULE_SINCE_RANGE
    );
  }

  get isShowSince() {
    return this.isTreatmentRPA;
  }

  get isShowSinceABool() {
    return this.isOtherRPA;
  }

  get isShowFrom() {
    return (
      this.ruleTemplate.dataTemplate.since &&
      this.sinceRangeSelected &&
      this.isTemplate1
    );
  }

  get isShowTo() {
    return (
      this.ruleTemplate.dataTemplate.since &&
      this.sinceRangeSelected &&
      this.isTemplate1
    );
  }

  get isShowConditionType() {
    return this.isTemplate1;
  }

  get isShowComparison() {
    return this.isTemplate1 || this.isTemplate2;
  }

  get isShowOtherVariable() {
    return this.isTemplate2;
  }

  get isShowEndCheckingAfter() {
    return this.afterIsInterVal;
  }

  get isDisableAction() {
    return this.isOtherRPA;
  }

  removeRule() {
    this.$emit("removeRule", this.ruleTemplate.ruleKey);
  }

  changeTemplate() {
    this.$emit("changeTemplate", this.ruleTemplate.ruleKey);
  }

}
